<template>
  <div class="external-content">
    <div class="animated fadeIn" style="position:relative">
      <b-card :header="$t('API')" style="position:relative">
        <iframe
          src="/apireference.html"
          frameborder="0"
          style="width:100%; min-height: 400px"
          ref="iframe"
        ></iframe>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.receiveMessageCB = this.receiveMessage.bind(this);
    window.addEventListener("message", this.receiveMessageCB, false);
  },
  destroyed() {
    window.removeEventListener("message", this.receiveMessageCB, false);
  },
  methods: {
    receiveMessage(event) {
      if (
        event &&
        event.data &&
        typeof event.data == "string" &&
        event.data.indexOf("[iframeResize]") > -1
      ) {
        let size = event.data.replace("[iframeResize]", "");
        this.$refs.iframe.style.height = `${parseInt(size) + 100}px`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.external-content {
  & /deep/ .card-body {
    padding: 0;
  }
}
</style>
